// extracted by mini-css-extract-plugin
export default {"container":"TabBar_container__sWj66","tabs":"TabBar_tabs__EfTkZ","active":"TabBar_active__eZ9jO"};